import { render, staticRenderFns } from "./ReportsPrimeCosts.vue?vue&type=template&id=2b6f091c&scoped=true&"
import script from "./ReportsPrimeCosts.vue?vue&type=script&lang=js&"
export * from "./ReportsPrimeCosts.vue?vue&type=script&lang=js&"
import style0 from "./ReportsPrimeCosts.vue?vue&type=style&index=0&id=2b6f091c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f091c",
  null
  
)

export default component.exports